import { type SchemaInsufficientItem } from '@/shared/api/openApi';

export class OrderReserveStocksError extends Error {
    public readonly insufficientItems?: SchemaInsufficientItem[];

    constructor(insufficientItems?: SchemaInsufficientItem[]) {
        super('ERROR_RESERVE_STOCKS');
        this.insufficientItems = insufficientItems;
    }
}
